var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dag-container"}},[_c('svg',{ref:"svgRoot",attrs:{"viewBox":("0 0 " + _vm.graphWidth + " " + _vm.graphHeight)}})])}
var staticRenderFns = []

export { render, staticRenderFns }